import * as React from 'react';
import type {GrowlType} from './store/growls';
import {useGrowlStore} from './store/growls';

import { View, Text, Touchable } from './libs/WebComponents';
import { Props } from './types/types';


const Growl = (props: Props)=> {

   props = {
      autoclose: true,
      dismissible: true,
      ...props
   };

   const [animate, setAnimate] = React.useState('animate');
   React.useEffect(()=>{
      setAnimate('');
      if (props.autoclose){
         setTimeout(_onCloseGrowl, Number.isInteger(props.autoclose)?props.autoclose:5000);
      }
   },[]);

   const _onCloseGrowl = ()=>{
      setAnimate('animate');
      setTimeout(props.onClose, 300);
   }
   return (
   <Touchable style={{flexDirection:'column',display:'flex',cursor:props.dismissible?'pointer':'default'}} onPress={props.dismissible?_onCloseGrowl:null} className={`growl slideInLeft ${props.dismissible?'':'disabled'} ${animate} alert alert-${props.type} `} role="alert">
      <Text style={{flex:10}}>{props.message}</Text>
   </Touchable>
);
   };


const Growls = () => {
   const { growls, removeGrowl } = useGrowlStore();
   const _onClose = (g: GrowlType)=>{
      const uuid = (g.uuid) ? g.uuid:999;
      removeGrowl(uuid);
   };
   return <View className={'growls-container m-3'}>{growls.map((g)=><Growl key={`growl-${g.uuid}`} {...g} onClose={()=>_onClose(g)}/>)}</View>;
}


export default React.memo(Growls);